import { useLatestApiKey } from '@/features/DataHub/modules/Export/hooks/useLatestApiKey';

/**
 * Default placeholder shown when user has no API key configured.
 * Used consistently across all export preview hooks.
 */
export const DEFAULT_API_KEY_PLACEHOLDER = '<YourApiKeyHere>';

/**
 * Returns the user's latest API key or a placeholder if none exists.
 * Use this hook in all export/preview contexts where a non-undefined API key is needed.
 */
export const useExportApiKey = () => {
  const latestApiKey = useLatestApiKey();

  return latestApiKey ?? DEFAULT_API_KEY_PLACEHOLDER;
};
